// A day cell of the weekly schedule of the contracts import: "08:00-16:00", several
// slots separated by ";". The database reads it the same way
// (fn_import_contracts_schedule_slots): keep both rules in step.

export type ScheduleSlotType = { start: string; end: string };

export type ScheduleCellResultType =
  | { slots: ScheduleSlotType[]; error?: undefined }
  | { slots?: undefined; error: string };

const SLOT_PATTERN = /^([01]?[0-9]|2[0-4]):([0-5][0-9])\s*-\s*([01]?[0-9]|2[0-4]):([0-5][0-9])$/;

const toTime = (hours: string, minutes: string) =>
  `${String(Number(hours) % 24).padStart(2, "0")}:${minutes}`;

/** Slots of one cell. Empty cell: no slots. 24:00 is midnight. */
export const parseScheduleCell = (value: string): ScheduleCellResultType => {
  const slots: ScheduleSlotType[] = [];

  for (const raw of value.split(";")) {
    const part = raw.trim();
    if (part === "") continue;

    const match = SLOT_PATTERN.exec(part);
    if (
      !match ||
      (match[1] === "24" && match[2] !== "00") ||
      (match[3] === "24" && match[4] !== "00")
    ) {
      return {
        error: `Horario no válido: "${part}". Usa el formato 08:00-16:00 y separa varios con punto y coma.`,
      };
    }

    slots.push({ start: toTime(match[1], match[2]), end: toTime(match[3], match[4]) });
  }

  return { slots };
};
